import { InjectionToken } from '@angular/core'
// Application config
export const APP_CONFIG = new InjectionToken('APP_CONFIG')
